<div class="container">

  <app-header-dialog [iconName]="'local_atm'">
    {{ local_title }}
  </app-header-dialog>

  <form class="form" name="entityForm" [formGroup]='entityForm' autocomplete="off">

    <mat-tab-group>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>local_atm</mat-icon>
          <div>Taxa</div>
        </ng-template>

        <div class='tab-content-id'>

          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Nome</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.name"
              autocomplete="off">
            <mat-error *ngIf="entityForm.controls.name.hasError('required')">
              O nome é obrigatório
            </mat-error>
          </mat-form-field>

          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Valor</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.value"
              autocomplete="off">
            <mat-error *ngIf="entityForm.controls.value.hasError('required')">
              O Valor é obrigatório.
            </mat-error>
          </mat-form-field>

        </div>

      </mat-tab>

    </mat-tab-group>

  </form>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
    <div [ngClass]="{hidden: !spinner}">
      <mat-spinner diameter="30"></mat-spinner>
    </div>
    <button mat-raised-button (click)='insert()' [disabled]="entityForm.invalid" *ngIf="!isEdit">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
    <button mat-raised-button (click)='update()' [disabled]="entityForm.invalid" *ngIf="isEdit">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
  </div>

</div>